import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  IAccountLangaugesRespDto,
  IAccountLanguagesIdsRespDto,
  IMessageResponseDto,
  IUpdateAccountLanguagesDto,
} from 'src/types'

class AccountLanguagesService extends EnhancedWithAuthHttpService {
  constructor() {
    super(new HttpService(axiosInstance))
  }

  getAccountLanguagesIds(accountId: string) {
    return this.get<IAccountLanguagesIdsRespDto>(`accounts-languages/${accountId}/ids`)
  }

  getAccountLanguages(accountId: string) {
    return this.get<IAccountLangaugesRespDto>(`accounts-languages/${accountId}`)
  }

  updateAccountLanguages(accountId: string, dto: IUpdateAccountLanguagesDto) {
    return this.put<IMessageResponseDto, IUpdateAccountLanguagesDto>(
      `accounts-languages/${accountId}`,
      dto,
    )
  }
}

export const accountLanguagesService = new AccountLanguagesService()
export default AccountLanguagesService
